document.addEventListener("DOMContentLoaded", function () {
  // Hide per-unit box on initial load if gated
  const gatedOnLoad = document.querySelector('.price[data-login-needed="true"]');
  if (gatedOnLoad) {
    const c = document.querySelector('.per-unit-container');
    if (c) c.classList.add('visually-hidden');
  }
 

  // Round down to two decimals
  function roundDownToTwoDecimals(num) {
    if (isNaN(num)) return null;
    return Math.floor(num * 100) / 100;
  }

  function maybeRedirect(id) { return; } // keep everything on-page

  // Update the price per unit display
  function updatePerUnitPrice(isModal = false) {
    const context = isModal ? document.querySelector('.modal-content') : document;

    // Skip updates if login callout is visible
    const loginVisible = context.querySelector('#bb-login-callout') &&
                         getComputedStyle(context.querySelector('#bb-login-callout')).display !== 'none';
    if (loginVisible) return;

    const priceElement = context.querySelector("#current-price .price");
    const discountPriceElement = context.querySelector("#discount-price #per-unit-price");
    const container = context.querySelector(".per-unit-container");

    if (!priceElement || !discountPriceElement) return;

    const price = parseFloat(priceElement.textContent.replace(/[^0-9.]/g, ""));
    if (isNaN(price)) return;

    let quantity = parseInt(discountPriceElement.getAttribute("data-units")) || 1;

    const selectedRadios = context.querySelectorAll('input[type="radio"]:checked');
    selectedRadios.forEach(radio => {
      const match = (radio.value || "").match(/\d+/);
      if (match) quantity = parseInt(match[0], 10);
    });

    if (!quantity || quantity <= 0) quantity = 1;

    if (price > 0 && quantity) {
      const perUnit = roundDownToTwoDecimals(price / quantity);
      const currentText = discountPriceElement.textContent.replace(/[^0-9.]/g, "");
      if (parseFloat(currentText) !== perUnit) {
        discountPriceElement.textContent = `$${perUnit.toFixed(2)}`;
        discountPriceElement.setAttribute("data-units", quantity);
        if (container) container.classList.remove("visually-hidden");
      }
    } else {
      discountPriceElement.textContent = "";
      if (container) container.classList.add("visually-hidden");
    }
  }

  // Recalculate on option/radio change
  document.addEventListener("change", function (event) {
    if (event.target.matches('input[type="radio"]')) {
      const isModal = event.target.closest('.modal-content') !== null;
      updatePerUnitPrice(isModal);
    }
  });

  // When quick shop opens, update inside modal
  document.addEventListener("click", function (event) {
    if (event.target.matches(".quick-shop-button")) {
      setTimeout(() => updatePerUnitPrice(true), 500);
    }
  });

  // Prevent stale calc when switching radios
  const variantRadios = document.querySelectorAll('input[type="radio"]');
  variantRadios.forEach(radio => {
    radio.addEventListener('click', function() {
      const currentlySelected = document.querySelector('input[type="radio"]:checked');
      if (currentlySelected && currentlySelected !== this) {
        updatePerUnitPrice();
      }
    });
  });

  // Hide per-unit box on collection pages
  if (window.location.pathname.includes("/collections/")) {
    const priceBox = document.querySelector("#discount-price");
    if (priceBox) priceBox.style.display = "none";
  }
});


// document.addEventListener("DOMContentLoaded", function () {
//   // Function to update the price per unit display
//   function updatePerUnitPrice(isModal = false) {
//     const context = isModal ? document.querySelector('.modal-content') : document;

//     const priceElement = context.querySelector("#current-price .price");
//     const discountPriceElement = context.querySelector("#discount-price #per-unit-price");
//     const container = context.querySelector(".per-unit-container");

//     // Exit if price or discount price elements are not found
//     if (!priceElement || !discountPriceElement) return;

//     // Parse the current price
//     const price = parseFloat(priceElement.textContent.replace(/[^0-9.]/g, ""));
//     if (isNaN(price)) return;

//     // Get the current quantity from the data attribute
//     let quantity = parseInt(discountPriceElement.getAttribute("data-units")) || 1;

//     // Check selected radio buttons for quantity
//     const selectedRadios = context.querySelectorAll('input[type="radio"]:checked');
//     selectedRadios.forEach(radio => {
//       const val = radio.value;
//       const match = val.match(/\d+/);
//       if (match) quantity = parseInt(match[0]);
//     });

//     // If no quantity is found, default to 1
//     if (!quantity || quantity <= 0) quantity = 1;

//     // Calculate and update the price per unit
//     if (price > 0 && quantity) {
//       const perUnit = (price / quantity).toFixed(2);
//       const currentText = discountPriceElement.textContent.replace(/[^0-9.]/g, "");
      
//       // Only update if the calculated price is different
//       if (parseFloat(currentText) !== parseFloat(perUnit)) {
//         discountPriceElement.textContent = `$${perUnit}`;
//         discountPriceElement.setAttribute("data-units", quantity);
//         if (container) container.classList.remove("visually-hidden");
//       }
//     } else {
//       discountPriceElement.textContent = "";
//       if (container) container.classList.add("visually-hidden");
//     }
//   }

//   // Event listener for changes to radio buttons
//   document.addEventListener("change", function (event) {
//     if (event.target.matches('input[type="radio"]')) {
//       const isModal = event.target.closest('.modal-content') !== null;
//       updatePerUnitPrice(isModal);
//     }
//   });

//   // Event listener for quick shop button clicks
//   document.addEventListener("click", function (event) {
//     if (event.target.matches(".quick-shop-button")) {
//       setTimeout(() => {
//         updatePerUnitPrice(true); // Pass true to indicate modal context
//       }, 500);
//     }
//   });

//   // Prevent loading the first variant when clicking on a different variant
//   const variantRadios = document.querySelectorAll('input[type="radio"]');
//   variantRadios.forEach(radio => {
//     radio.addEventListener('click', function() {
//       const currentlySelected = document.querySelector('input[type="radio"]:checked');
//       if (currentlySelected && currentlySelected !== this) {
//         updatePerUnitPrice();
//       }
//     });
//   });

//   // Hide the price box on collection pages
//   if (window.location.pathname.includes("/collections/")) {
//     const priceBox = document.querySelector("#discount-price");
//     if (priceBox) priceBox.style.display = "none";
//   }
// });






